<template>
  <div id="login">
    <v-card elevation="15" max-width="100%" >
      <div
        class="d-flex flex-column justify-space-between align-center"
        v-if="dataReady"
      >
        <v-container>

         <div class="d-flex flex-column justify-space-between align-center">
            <v-img
              id="img_vg"
              :src="require('@/assets/LOGO_VGROUP_HONDA_RED.png')"
            ></v-img>
          </div>
         <div class="d-flex flex-column justify-space-between align-center">
          <h1>{{dateShow}}</h1>
          </div>
          <br />
          <pre style="margin-left: -45px">
          <label >ตัวอย่าง</label>
          <label style="color:#871B12" >Username : Anurak.dau</label>
          <label >(ชื่อภาษาอังฤษ จุด นามสกุลสามตัวแรก)</label>
          <label style="color:#871B12">Password : 1234567890123</label>
          <label >(เลขที่บัตรประชาชน)</label>
          </pre>
          <v-text-field
           outlined
            prepend-icon="mdi-account"
            v-model="formLogin.userName"
            autocomplete="off"
            label="Username"
          ></v-text-field>
          <v-text-field
           outlined
            prepend-icon="mdi-lock"
            v-model="formLogin.userPassword"
            autocomplete="off"
            label="Password"
            type="password"
          ></v-text-field>

           <template v-if="dataReady">
        <v-card class="mx-auto my-2 text-left" elevation="12">
          <v-card-text>
            <div class="text--primary">
              1) คุณมีอุณหภูมิร่างกายตั้งแต่ 37.5 องศาขึ้นไป หรือตัวร้อนแบบมีไข้ หรือไม่
            </div>
          </v-card-text>
          <v-card-text>
            <center>
              <v-chip-group
                active-class="deep-purple accent-4 white--text text-center"
                column
                v-model="selection1"
                style="margin-left: 25%"
              >
                <v-chip v-on:click="form.formSaveRisk1 = 1">ใช่ (Yes)</v-chip>

                <v-chip v-on:click="form.formSaveRisk1 = 0"
                  >ไม่ใช่ (None)</v-chip
                >
              </v-chip-group>
            </center>
          </v-card-text>
        </v-card>
        <v-card class="mmx-auto my-2 text-left" elevation="12">
          <v-card-text>
            <div class="text--primary">
               2) คุณมีอาการอย่างใดอย่างหนึ่ง จากรายการดังต่อไปนี้  <br> (เลือกได้มากกว่า 1) (ไม่พบอาการใดๆ ไม่ต้องเลือก)
            </div>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="4"
          >
            <v-checkbox
              v-model="selection21"
              label="ไอ"
              color="red"
              value="ไอ"
              hide-details
            ></v-checkbox>
            <v-checkbox
              v-model="selection21"
              label="มีน้ำมูก"
              color="red darken-3"
              value="มีน้ำมูก"
              hide-details
            ></v-checkbox>
             <v-checkbox
              v-model="selection21"
              label="เจ็บคอ"
              color="indigo"
              value="เจ็บคอ"
              hide-details
            ></v-checkbox>
             <v-checkbox
              v-model="selection21"
              label="เจ็บหน้าอก"
              color="orange"
              value="เจ็บหน้าอก"
              hide-details
            ></v-checkbox>
            <v-checkbox
              v-model="selection21"
              label="แน่นหน้าอก"
              color="orange darken-3"
              value="แน่นหน้าอก"
              hide-details
            ></v-checkbox>
            <v-checkbox
              v-model="selection21"
              label="หายใจเร็ว หรือ หายใจลำบาก"
              color="indigo darken-3"
              value="หายใจเร็ว หรือ หายใจลำบาก"
              hide-details
            ></v-checkbox>
            <v-checkbox
              v-model="selection21"
              label="จมูกไม่ได้กลิ่น"
              color="red"
              value="จมูกไม่ได้กลิ่น"
              hide-details
            ></v-checkbox>
            <v-checkbox
              v-model="selection21"
              label="มีผื่นแดง"
              color="red darken-3"
              value="มีผื่นแดง"
              hide-details
            ></v-checkbox>
             <v-checkbox
              v-model="selection21"
              label="ท้องเสีย"
              color="indigo"
              value="ท้องเสีย"
              hide-details
            ></v-checkbox>
          </v-col>
        </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mx-auto my-2 text-left" elevation="12">
          <v-card-text>
            <div class="text--primary">
              3) คุณมีประวัติสัมผัสบุคคล(ความเสี่ยงสูง)ที่ใกล้ชิดกับผู้ติดเชื้อ COVID-19  ใช่หรือไม่
            </div>
          </v-card-text>
          <v-card-text>
            <center>
              <v-chip-group
                active-class="deep-purple accent-4 white--text text-center"
                column
                v-model="selection3"
                style="margin-left: 25%"
              >
                <v-chip v-on:click="form.formSaveRisk3 = 1">ใช่ (Yes)</v-chip>

                <v-chip v-on:click="form.formSaveRisk3 = 0"
                  >ไม่ใช่ (None)</v-chip
                >
              </v-chip-group>
            </center>
          </v-card-text>
        </v-card>
        <v-card class="mx-auto my-2 text-left" elevation="12">
          <v-card-text>
            <div class="text--primary">
              4) คุณมีบุคคลภายในครอบครัวที่พักอาศัยร่วมกัน เสี่ยงสัมผัสกับผู้ติดเชื้อ COVID-19 ในช่วง 14 วันใช่หรือไม่
            </div>
          </v-card-text>
          <v-card-text>
            <center>
              <v-chip-group
                active-class="deep-purple accent-4 white--text text-center"
                column
                v-model="selection4"
                style="margin-left: 25%"
              >
                <v-chip v-on:click="form.formSaveRisk4 = 1">ใช่ (Yes)</v-chip>

                <v-chip v-on:click="form.formSaveRisk4 = 0"
                  >ไม่ใช่ (None)</v-chip
                >
              </v-chip-group>
            </center>
          </v-card-text>
        </v-card>
        <v-card class="mx-auto my-2 text-left" elevation="12">
          <v-card-text>
            <div class="text--primary">
              5. ในช่วงระยะเวลา 3-5 วันที่ผ่านมา ท่านมีประวัติเดินทางไปสถานที่ ทีมีการรวมกลุ่มคน หรือชุมชน เช่น ตลาดนัด ห้างสรรพสินค้า สถานพยาบาล หรือ ขนส่งสาธารณะใช่ หรือไม่
            </div>
          </v-card-text>
          <v-card-text>
            <center>
              <v-chip-group
                active-class="deep-purple accent-4 white--text text-center"
                column
                v-model="selection5"
                style="margin-left: 25%"
              >
                <v-chip v-on:click="form.formSaveRisk5 = 1">ใช่ (Yes)</v-chip>

                <v-chip v-on:click="form.formSaveRisk5 = 0"
                  >ไม่ใช่ (None)</v-chip
                >
              </v-chip-group>
            </center>
          </v-card-text>
        </v-card>
        <v-card class="mx-auto my-2 text-left" elevation="12">
          <v-card-text>
            <div class="text--primary">
              6) คุณมีประวัติการสัมผัส หรือ ใกล้ผู้ป่วย Covid 19 มากกว่า 5 นาที ใช่หรือไม่
            </div>
          </v-card-text>
          <v-card-text>
            <center>
              <v-chip-group
                active-class="deep-purple accent-4 white--text text-center"
                column
                v-model="selection6"
                style="margin-left: 25%"
              >
                <v-chip v-on:click="form.formSaveRisk6 = 1">ใช่ (Yes)</v-chip>

                <v-chip v-on:click="form.formSaveRisk6 = 0"
                  >ไม่ใช่ (None)</v-chip
                >
              </v-chip-group>
            </center>
          </v-card-text>
        </v-card>
        <v-card class="mx-auto my-2 text-left" elevation="12">
          <v-card-text>
            <div class="text--primary">
              7) คุณเป็นผู้ป่วย Covid 19 ใช่หรือไม่
            </div>
          </v-card-text>
          <v-card-text>
            <center>
              <v-chip-group
                active-class="deep-purple accent-4 white--text text-center"
                column
                v-model="selection7"
                style="margin-left: 25%"
              >
                <v-chip v-on:click="form.formSaveRisk7 = 1">ใช่ (Yes)</v-chip>

                <v-chip v-on:click="form.formSaveRisk7 = 0"
                  >ไม่ใช่ (None)</v-chip
                >
              </v-chip-group>
            </center>
          </v-card-text>
        </v-card>

        </template>
          <v-row >
          <v-col cols="6">
            <v-btn color="success" dark block x-large  @click="onSubmit('IN')" >  <v-icon dark> mdi-alarm-check </v-icon>เข้างาน</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="purple" dark block x-large  @click="onSubmit('OUT')" > <v-icon dark> mdi-alarm-check </v-icon> ออกงาน</v-btn>
          </v-col>
        </v-row>

          <!-- <template>
            <v-btn color="teal" @click="onSubmit()" dark large block
              >Login</v-btn
            >
          </template> -->

        </v-container>
      </div>
      <div v-if="!dataReady" class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import covidSelect from '../../assets/master/covid/covidSelect.json'
import VuetifyLogo from '../logo'
import moment from 'moment'
export default {
  components: {
    VuetifyLogo
  },
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_checkinout }, function (data) {})
  },
  data () {
    return {
      profile: [],
      menu: [],
      data: [],
      dataShiftItem: [],
      date: new Date(),
      dateShow: '',
      formLogin: {
        userLineuserId: '',
        userLinepictureUrl: '',
        userName: '',
        userPassword: ''
      },
      dataReady: true,

      center: {},
      shiftItem: [],
      checkItem: [],
      placeId: '',
      geocoder: null,
      dialog_checkin_success: false,
      dialog_checkout_success: false,
      selection1: 1,
      selection2: 1,
      selection21: [],
      selection3: 1,
      selection4: 1,
      selection5: 1,
      selection6: 1,
      selection7: 1,
      form: {
        userLineuserId: '',
        userIDCard: '',
        userType: '',
        displayNameTh: '',
        userPhone: '',
        formSaveRisk1: 0,
        formSaveRisk2: 0,
        formSaveRisk21: [],
        formSaveRisk3: 0,
        formSaveRisk4: 0,
        formSaveRisk5: 0,
        formSaveRisk6: 0,
        formSaveRisk7: 0,
        formSaveRisk8: 0,
        // ที่อยู่
        locationLat: '',
        locationLong: '',
        // สี
        COLOR: ''
      },
      resultList: covidSelect,
      disableBtnCheckIn: true,
      disableBtnCheckOut: true,
      AccessKey: '',
      ApplicationKey: '',
      checkTimeAfterCheckIN: true,
      imageQuest: '',
      gen_action: ''
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    await this.geolocate()
  },
  created () {
    setInterval(this.getNow, 1000)
  },
  methods: {
    async geolocate () {
      this.dataReady = false
      await navigator.geolocation.getCurrentPosition(
        async (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          if (center) {
            this.center = center
            this.dataReady = true
            this.locationStatus = true
            console.log('this.center', center)
          }
        },
        (error) => {
          this.dataReady = true
          this.center.lat = null
          this.center.lng = null
          this.locationStatus = true
          console.log('this.center err: ', this.center)
          console.log('error map :', error.message)
        }
      )
      this.locationStatus = true
      // console.log('locatio', this.center)
    },
    getNow () {
      const today = new Date()
      const time =
        today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
      this.dateShow = time
    },
    async onSubmit (INOUT) {
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/auth?userName=' +
            this.formLogin.userName +
            '&userPassword=' +
            this.formLogin.userPassword
        )
        .then(async (response) => {
          if (response.data[0].empCode) {
            this.profile = response.data[0]
            this.formLogin.LAST_USER = this.formLogin.userName
            this.assessmentUser(response.data[0], INOUT)
          } else {
            this.$swal('ไม่พบรหัสพนักงาน', 'คุณไม่มีสิทธิ์เข้าใช้ระบบ กรุณาติดต่อฝ่ายบุคคล', 'error'
            )
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'Account ไม่ถูกต้อง2', 'error')
          console.log('onSubmit', error)
        })
    },
    async assessmentUser (emp, INOUT) {
      this.checkAfterCheckIN = false
      if (emp.empCode) {
        this.dataReady = true
        this.form.formSaveRisk2 = 0
        // console.log('selection21', this.selection21.length)
        if (this.selection21.length > 0) {
          this.form.formSaveRisk2 = 1
          this.form.formSaveRisk21 = JSON.stringify(this.selection21)
        } else {
          this.form.formSaveRisk21 = null
        }

        var Risk78 = 0

        await this.resultList.forEach(async (element, index) => {
          Risk78 = (this.form.formSaveRisk7 === 1 || this.form.formSaveRisk8 === 1) ? 1 : 0
          if (
            element.fever === this.form.formSaveRisk1 &&
          element.one_uri_symp === this.form.formSaveRisk2 &&
          element.travel_risk_country === this.form.formSaveRisk3 &&
          element.covid19_contact === this.form.formSaveRisk4 &&
          element.close_risk_location === 0 &&
          element.close_risk_country === this.form.formSaveRisk5 &&
          element.int_contact === this.form.formSaveRisk6 &&
          element.med_prof === Risk78 &&
          element.close_con === Risk78
          ) {
            switch (element.risk_level) {
              case 1:
                this.form.COLOR = 'สีเขียว'
                break
              case 2:
                this.form.COLOR = 'สีเหลือง'
                break
              case 3:
                this.form.COLOR = 'สีส้ม'
                break
              case 4:
                this.form.COLOR = 'สีส้ม'
                break
              case 5:
                this.form.COLOR = 'สีแดง'
                break
            }

            if (this.form.formSaveRisk7 === 1) {
              this.form.COLOR = 'สีแดง'
            }
            this.gen_action = element.gen_action
          }
        })

        var dataRisk = {
          formSaveRisk1: this.form.formSaveRisk1 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk2: this.form.formSaveRisk2 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk3: this.form.formSaveRisk3 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk4: this.form.formSaveRisk4 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk5: this.form.formSaveRisk5 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk6: this.form.formSaveRisk6 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk7: this.form.formSaveRisk7 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk8: this.form.formSaveRisk8 === 1 ? 'ใช่' : 'ไม่ใช่',
          formSaveRisk21: this.form.formSaveRisk21,
          Lat: this.center.lat,
          Long: this.center.lng,
          COLOR: this.form.COLOR,
          empCode: emp.empCode,
          userLineuserId: emp.userLineuserId,
          year: moment().format('YYYY'),
          month: moment().format('MM'),
          day: moment().format('D')
        }

        await this.updateDisable(dataRisk, INOUT)

        console.log(dataRisk)
      } else {
        alert('ไม่พบข้อมูลพนักงาน')
        location.reload()
      }
    },
    async updateDisable (dataRisk, INOUT) {
      const result = await axios.post(this.DNS_IP + '/rick_assessment/addAndUpdateDisable', dataRisk)
      if (result.data.status) {
        await this.getDataShift(dataRisk.empCode, INOUT)
        await this.linenotify(dataRisk)
      }
    },
    async _assessmentUser (emp, INOUT) {
      this.dataReady = true
      console.log('assessmentUser', INOUT, emp)
      this.form.formSaveRisk2 = 0

      if (this.selection21.length > 0) {
        this.form.formSaveRisk2 = 1
        this.form.formSaveRisk21 = JSON.stringify(this.selection21)
      } else {
        this.form.formSaveRisk21 = null
      }

      for (let key in this.resultList) {
        var result = this.resultList[key]
        var Risk78 = 0
        if (this.form.formSaveRisk7 === 1 || this.form.formSaveRisk8 === 1) {
          Risk78 = 1
        }

        if (
          result.fever === this.form.formSaveRisk1 &&
          result.one_uri_symp === this.form.formSaveRisk2 &&
          result.travel_risk_country === this.form.formSaveRisk3 &&
          result.covid19_contact === this.form.formSaveRisk4 &&
          result.close_risk_location === 0 &&
          result.close_risk_country === this.form.formSaveRisk5 &&
          result.int_contact === this.form.formSaveRisk6 &&
          result.med_prof === Risk78 &&
          result.close_con === Risk78
        ) {
          switch (result.risk_level) {
            case 1:
              this.form.COLOR = 'สีเขียว'
              break
            case 2:
              this.form.COLOR = 'สีเหลือง'
              break
            case 3:
              this.form.COLOR = 'สีส้ม'
              break
            case 4:
              this.form.COLOR = 'สีส้ม'
              break
            case 5:
              this.form.COLOR = 'สีแดง'
              break
          }

          if (this.form.formSaveRisk7 === 1) {
            this.form.COLOR = 'สีแดง'
          }

          this.gen_action = result.gen_action

          var resultText = '<h4>' + emp.empFull_NameTH + '</h4>' +
          '<h4>ความเสี่ยงระดับ: <b>' + this.form.COLOR + '</b></h4>' +
          '<h6>ข้อแนะนำ: ' + result.gen_action + '</h6>'

          if (result.spec_action !== '') {
            resultText += '<h6>ข้อควรปฏิบัติ: ' + result.spec_action + '</h6>'
          }

          const today = new Date()
          var dataRisk = {
            formSaveRisk1: this.form.formSaveRisk1 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk2: this.form.formSaveRisk2 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk3: this.form.formSaveRisk3 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk4: this.form.formSaveRisk4 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk5: this.form.formSaveRisk5 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk6: this.form.formSaveRisk6 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk7: this.form.formSaveRisk7 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk8: this.form.formSaveRisk8 === 1 ? 'ใช่' : 'ไม่ใช่',
            formSaveRisk21: this.form.formSaveRisk21,
            Lat: this.center.lat,
            Long: this.center.lng,
            COLOR: this.form.COLOR,
            empCode: emp.empCode,
            userLineuserId: emp.userLineuserId,
            year: today.getFullYear(),
            month: (today.getMonth() + 1),
            day: today.getDate()
          }

          console.log('dataRisk', dataRisk)

          this.dataReady = true
          var colorLevel = ''
          if (this.form.COLOR === 'สีเขียว') {
            colorLevel = 'Green'
          }
          if (this.form.COLOR === 'สีเหลือง') {
            colorLevel = 'Yellow'
          }
          if (this.form.COLOR === 'สีส้ม') {
            colorLevel = 'Orange'
          }
          if (this.form.COLOR === 'สีแดง') {
            colorLevel = 'Red'
          }
          var urlPic = '/static/img/' + colorLevel + '.jpg'

          this.$swal({
            title: '<strong>ผลการประเมิน</strong>',
            imageUrl: urlPic,
            html: resultText,
            allowOutsideClick: false
          })
            .then(async (response) => {
              await axios
                .post(
                  this.DNS_IP +
                  '/rick_assessment/addAndUpdateDisable',
                  dataRisk
                )
                .then(async (response) => {
                  // console.log(response)
                  // await axios
                  //   .post(
                  //     this.DNS_IP +
                  // '/rick_assessment/add',
                  //     dataRisk
                  //   )
                  //   .then(async (response) => {
                  await this.getDataShift(emp.empCode, INOUT)

                  await this.linenotify(dataRisk)

                  //     // eslint-disable-next-line handle-callback-err
                  //   }).catch((error) => {
                  //     this.dataReady = true
                  //   })
                // eslint-disable-next-line handle-callback-err
                }).catch((error) => {
                  this.dataReady = true
                })
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
            })
        }
      }
    },
    async getDataShift (empCode, INOUT) {
      const today = new Date()
      this.shiftItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            empCode +
            '&shiftMonth=' +
            (today.getMonth() + 1) +
            '&shiftYear=' +
            today.getFullYear() +
            '&shiftDay=' +
            today.getDate()
        )
        .then(async (response) => {
          this.shiftItem = response.data[0]
          console.log('shift', response.data[0], INOUT)
          this.dataReady = false
          if (INOUT === 'IN') {
            if (this.shiftItem.checkInStartStamp) {
              this.$swal('', 'ท่านได้ เข้างาน เรียบร้อยแล้ว', 'success')
            } else {
              this.checkIn(empCode)
            }
          }
          if (INOUT === 'OUT') {
            if (this.shiftItem.checkInEndStamp) {
              this.$swal('', 'ท่านได้ ออกงาน เรียบร้อยแล้ว', 'success')
            } else {
              this.checkOut(empCode)
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
          this.$swal(
            'ไม่มีข้อมูล',
            'วันนี้ท่านไม่มีข้อมูลกะ การทำงาน',
            'error'
          )
        })
    },
    async checkIn (empCode) {
      this.dataReady = true
      const currentDateTIme = moment(moment().format('YYYY-MM-DD HH:ss'), 'YYYY-mm-dd HH:ss')
      const masShiftTypeBeforeStart = moment(moment().format('YYYY-MM-DD') + ' ' + this.shiftItem.masShiftTypeBeforeStart, 'YYYY-mm-dd HH:ss')

      if (currentDateTIme.diff(masShiftTypeBeforeStart) > 0) {
        let ds = {
          empCode: empCode,
          masShiftTypeCode: this.shiftItem.shiftCode,
          checkInStartLat: this.center.lat,
          checkInStartLong: this.center.lng,
          location: 'Office',
          startDate: this.shiftItem.masShiftTypeStartTime,
          leave: this.shiftItem.leave,
          masShiftBreakEnd: this.shiftItem.masShiftBreakEnd,
          leaveSummaryDayName: this.shiftItem.leaveSummaryDayName,
          remark: 'Check IN Office (HR&GA)',
          checkInMapUrl: (this.center.lat) ? `https://www.google.co.th/maps/search/${this.center.lat},${this.center.lng}/@${this.center.lat},${this.center.lng},17z` : null //
        }
        console.log(ds)
        await this.addData(ds)
      } else {
        this.dataReady = false
        alert('สามารถเริ่มเข้าได้ตั้งแต่เวลา ' + masShiftTypeBeforeStart.format('HH:ss'))
      }
    },
    async linenotify (dt) {
      // console.log()
      // alert(dt.COLOR)
      if (dt.COLOR === 'สีส้ม' || dt.COLOR === 'สีแดง') {
        await axios
          .get(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/line_notify_covid/get?notifyCovidType=แจ้งเตือนประเมินความเสี่ยง",
            {
              headers: {
                'Application-Key': this.$session.getAll().ApplicationKey
              }
            }
          )
          .then(async (response) => {
            this.dataReady = true
            // console.log(response.data.captionName)
            response.data.forEach(async data => {
              console.log(data.notifyCovidToken)
              var textRisk = ''
              if (dt.formSaveRisk1 === 'ใช่') { textRisk += '\n 😷 มีอุณหภูมิกายตั้งแต่ 37.5 องศาขึ้นไป หรือตัวร้อนแบบมีไข้' }
              if (dt.formSaveRisk2 === 'ใช่') { textRisk += '\n 😷 ' + dt.formSaveRisk21 }
              if (dt.formSaveRisk3 === 'ใช่') { textRisk += '\n 😷 มีประวัติเดินทางไปยัง หรือ มาจาก พื้นที่เกิดโรค COVID-19 ในช่วงเวลา 10 วัน ก่อน' }
              if (dt.formSaveRisk4 === 'ใช่') { textRisk += '\n 😷 มีบุคคลภายในครอบครัวที่พักอาศัยร่วมกันติดเชื้อ COVID-19 ในช่วง 10 วัน' }
              if (dt.formSaveRisk5 === 'ใช่') { textRisk += '\n 😷 มีประวัติเดินทางไปสถานที่ที่มีการรวมกลุ่มคน หรือ ชุมชน เช่น ตลาดนัด ห้างสรรพสินค้า สถานพยาบาล หรือ ขนส่งสาธารณะ' }
              if (dt.formSaveRisk6 === 'ใช่') { textRisk += '\n 😷 มีประวัติการสัมผัส หรือ ใกล้ผู้ป่วย Covid 19 เป็นมากกว่า 5 นาที' }
              if (dt.formSaveRisk7 === 'ใช่') { textRisk += '\n 😷 เป็นผู้ป่วย Covid 19' }

              const today = new Date()
              const time = today.getHours() + ':' + today.getMinutes()
              var massageNoti = 'พบผู้มีความเสี่ยงติดโควิดระดับ' + this.form.COLOR +
            '\n\nชื่อผู้ประเมิน : ' + this.profile.empFull_NameTH +
            '\nแผนก : ' + this.profile.masDepartmentName +
            '\nสาขา : ' + this.profile.masBranchName +
            '\nบริษัท : ' + this.profile.masCompanyName +
            '\nเบอร์โทรศัพท์ติดต่อ : ' + this.profile.empTel +
            '\nวันที่ประเมิน : ' + 'วันที่ ' + today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear() + ' เวลา ' + time +
            '\n\nความเสี่ยงที่พบ : ' + textRisk

              var ds = {
                token: data.notifyCovidToken,
                message: massageNoti
              }

              await axios
                .post(
                // eslint-disable-next-line quotes
                  this.DNS_IP + "/line/hrm_notify",
                  ds, {
                    headers: {
                      'Application-Key': localStorage.getItem('ApplicationKey')
                    }
                  }
                )
                .then(async (response) => {
                  console.log(response)
                })
              // eslint-disable-next-line handle-callback-err
                .catch((error) => {
                  console.log('linenotify: ', error)
                })
            })
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            // this.dataReady = true
            console.log(error)
          })
      }
    },
    async addData (ds) {
      await axios.post(this.DNS_IP + '/ch_checkin/add', ds)
        .then(async (response) => {
          this.dataReady = true
          this.$swal({
            title: 'ท่านได้ลงเวลาเข้างาน สำเร็จ',
            type: 'success'
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async checkOut (empCode) {
      this.dataReady = true
      var checkInEndStamp = moment(moment().format('YYYY-MM-DD HH:mm'))
      var masShiftTypeEndTime = moment(moment().format('YYYY-MM-DD') + ' ' + this.shiftItem.masShiftTypeEndTime)
      var masShiftTypeEndAfterTime = moment(moment().format('YYYY-MM-DD') + ' ' + this.shiftItem.masShiftTypeAfterEnd)
      if (this.shiftItem.leaveSummaryDayName && this.shiftItem.leaveSummaryDayName === 'ครึ่งวันบ่าย') {
        masShiftTypeEndTime = moment(moment().format('YYYY-MM-DD') + ' ' + this.shiftItem.masShiftBreakStart)
      }
      var durationCheckOut = checkInEndStamp.diff(masShiftTypeEndTime)
      var durationAfterCheckOut = masShiftTypeEndAfterTime.diff(checkInEndStamp)
      let ds = {
        empCode: empCode,
        masShiftTypeCode: this.shiftItem.shiftCode,
        checkInEndLat: this.center.lat,
        checkInEndLong: this.center.lng,
        endDate: this.shiftItem.masShiftTypeEndTime,
        masShiftBreakStart: this.shiftItem.masShiftBreakStart,
        leaveSummaryDayName: this.shiftItem.leaveSummaryDayName,
        checkOutMapUrl: (this.center.lat) ? `https://www.google.co.th/maps/search/${this.center.lat},${this.center.lng}/@${this.center.lat},${this.center.lng},17z` : null//
      }

      if (durationCheckOut >= 0) {
        if (durationAfterCheckOut > 0) {
          await this.updateData(ds)
        } else {
          this.$swal({
            text: 'ท่านไม่สามารถ ลงเวลาออกงาน หลังเวลา ' + this.shiftItem.masShiftTypeAfterEnd,
            type: 'warning',
            showCancelButton: false,
            confirmButtonText: 'ปิด'
          })
            .then(async (result) => {
              this.dataReady = true
            })
            .catch((error) => {
              console.log(error)
              this.dataReady = true
            })
        }
      } else {
        this.$swal({
          title: 'ท่านลงเวลาออกงาน ก่อน กะการทำงานของท่าน จะดำเนินการต่อหรือไม่ ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async (result) => {
            await this.updateData(ds)
          })
          .catch((error) => {
            console.log(error)
            this.dataReady = true
          })
      }
    },
    async updateData (ds) {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/ch_checkin/getToDay?empCode=' +
            ds.empCode
        )
        .then(async (response) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/ch_checkin/edit/" + response.data.checkInId,
              ds
            )
            .then(async (response) => {
              this.dataReady = true
              this.$swal({
                title: 'ท่านได้ลงเวลาออกงาน สำเร็จ',
                type: 'success'
              })
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function updateData : ', error)
              this.dataReady = true
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
h1,
h3,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
h3 {
  text-align: center;
}
.a >>> .ql-align-center {
  text-align: center;
}
a {
  color: #42b983;
}
#danger {
  color: red;
}
#login {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 5px; */
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 60px;
}

.a.data-450 {
  max-height: 450px;
  overflow-y: auto;
  /* margin-bottom: -10px; */
}
#img_vg {
  width: 150px;
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/CheckINOffice.vue